export default "__VITE_ASSET__DaeSPvBi__"